<div [class]="'c-add-manual-item__section '+ stepStatus">

  <!--section header-->
  <div class="c-add-manual-item__section-header">
            <span class="c-add-manual-item__section-number">
                <svg class="a-icon c-add-manual-item__header-icon">
                   <use xlink:href="#tick"></use>
                </svg>
                2
            </span>
    <div class="c-add-manual-item__section-title">
      <h4 class="t3 ts-normal">Specify PNR / Trip ID number </h4>
      <span class="s6-text tc-muted">Enter valid PNR / Trip ID to search flight criteria</span>
    </div>
    <button class="a-link-btn a-link-btn--primary c-add-manual-item__section-edit">
      <svg class="a-icon u-rmr u-x1.25">
        <use xlink:href="#edit"></use>
      </svg>
      Edit
    </button>
  </div>

  <div class="c-add-manual-item__section__content" *ngIf="stepStatus === MODAL_STEP.isActive">
    <div class="c-add-manual-item__form">

      <div class="o-inline-form-group c-add-manual-item__form-group">
        <div class="o-inline-form-group__item c-add-manual-item__form-item c-add-manual-item__form-item--dual">

          <div class="m-form-field surf-multi-input surf-multi-input--1-3 {{defaultGDS}}">
            <surf-multi-field-input
              [properties]="properties"
              [componentValue]="componentValue"
              [title]="'PNR / Trip ID'"
              [disabled]="disabled"
              [error]="error"
              [msg]="msg"
              [emitOnKeyUp]="emitOnKeyUp"
              [wrapeprView]="wrapperView"
              [isCapital]="true"
              [isPNR]="true"
              [ratioOne]="'1'"
              [ratioTwo]="'3'"
              (emitValues)="onValueChange($event)"
              (isValid)="setValidInput($event)">
            </surf-multi-field-input>
            <label *ngIf="isDP" class="a-checkbox u-rmt u-block">
              <input type="checkbox" class="a-checkbox__check" [disabled]="isSabre" (change)="checkValue($event)" [checked]="usePNRPriceRecord">
              <span class="a-checkbox__label">Use PNR price record</span>
            </label>
          </div>

        </div>
      </div>

    </div>
  </div>

</div>
